import React, {ReactNode} from 'react'
import Select, {OnChangeValue} from 'react-select'
import {CondominiumGroupData} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import FormErrorMessage from '../../../components/shared/forms/FormErrorMessage'
import {ErrorHandlingFormProps} from '../../../components/shared/forms/hoc/createErrorHandlingForm'
import {withErrorSubscribe} from '../../../components/shared/forms/hoc/withErrorSubscribe'
import {isMobile} from 'react-device-detect'
import PPSelect from '../../../components/shared/forms/PPSelect'
import {SelectChangeEvent} from '@mui/material/Select'

const SELECT_CONDOMINIUM_GROUP_PLACEHOLDER = '物件グループを選択してください'

interface Props {
    children?: ReactNode
    condominiumGroup: CondominiumGroupData
    defaultValue: number | null
    onChangeSelectedCondominiumGroupId:
        (selectedCondominiumGroupId: number, selectedCondominiumGroupName?: string) => void
    requiredFlag: boolean
    autoFocus?: boolean
}

interface States {
    selectedCondominiumGroup: CondominiumGroupListItem
    condominiumGroupList: CondominiumGroupListItem[]
    defaultLabel: string
    selectedLabel: string
}

interface CondominiumGroupListItem {
    label: string
    value: number
}

class NatCondominiumGroupSelectComponent
    extends React.Component<Props & ErrorHandlingFormProps, States> {

    constructor(props: Readonly<Props & ErrorHandlingFormProps>) {
        super(props)

        const condominiumGroupList: { label: string, value: number | string }[] = []
        if (!this.props.requiredFlag) {
            condominiumGroupList.push({
                label: SELECT_CONDOMINIUM_GROUP_PLACEHOLDER,
                value: '',
            })
        }
        condominiumGroupList.push({
            label: this.props.condominiumGroup.level1CondominiumGroupName,
            value: this.props.condominiumGroup.level1CondominiumGroupId,
        })
        if (this.props.condominiumGroup.level2CondominiumGroupInfo) {
            this.props.condominiumGroup.level2CondominiumGroupInfo.forEach((level2Info) => {
                if (level2Info.level2CondominiumGroupId && level2Info.level2CondominiumGroupName) {
                    condominiumGroupList.push({
                        label: '　' + level2Info.level2CondominiumGroupName,
                        value: level2Info.level2CondominiumGroupId,
                    })
                }
                if (level2Info.level3CondominiumGroupInfo) {
                    level2Info.level3CondominiumGroupInfo.forEach((level3Info) => {
                        if (level3Info.level3CondominiumGroupId && level3Info.level3CondominiumGroupName) {
                            condominiumGroupList.push({
                                label: '　　' + level3Info.level3CondominiumGroupName,
                                value: level3Info.level3CondominiumGroupId,
                            })
                        }
                        if (level3Info.level4CondominiumGroupInfo) {
                            level3Info.level4CondominiumGroupInfo.forEach((level4Info) => {
                                if (level4Info.level4CondominiumGroupId && level4Info.level4CondominiumGroupName) {
                                    condominiumGroupList.push({
                                        label: '　　　' + level4Info.level4CondominiumGroupName,
                                        value: level4Info.level4CondominiumGroupId,
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }

        const options: any[] = []
        let defaultLabel: string = ''
        condominiumGroupList.forEach((condominiumGroup) => {
            if (condominiumGroup.value === this.props.defaultValue) {
                defaultLabel = condominiumGroup.label
            }
            options.push({value: condominiumGroup.value, label: condominiumGroup.label})
        })

        let defaultSelectedCondominiumGroup: CondominiumGroupListItem
        if (this.props.defaultValue) {
            defaultSelectedCondominiumGroup = {label: defaultLabel, value: this.props.defaultValue}
        } else {
            defaultSelectedCondominiumGroup = {label: SELECT_CONDOMINIUM_GROUP_PLACEHOLDER, value: 0}
        }

        this.state = {
            selectedCondominiumGroup: defaultSelectedCondominiumGroup,
            condominiumGroupList: options,
            defaultLabel: defaultLabel,
            selectedLabel: defaultLabel,
        }

        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
    }

    onChangeCondominiumGroupId(value: OnChangeValue<CondominiumGroupListItem, false>): void {
        if (value === null) {
            return
        }

        this.setState({
            selectedCondominiumGroup: value,
            selectedLabel: value.label.trim(),
        })
        // 項目で表示しているエラーメッセージをクリア
        if (this.props.clearErrorMessage) {
            this.props.clearErrorMessage()
        }
        const selectedValue = value.value
        const selectedLabel = value.label
        this.props.onChangeSelectedCondominiumGroupId(selectedValue, selectedLabel)
    }

    onChangeCondominiumGroupIdM = (event: SelectChangeEvent<unknown>): void => {
        const value = event.target.value as string
        const selectedCondominiumGroup = this.state.condominiumGroupList
            .find(option => `${option.value}` === value)
        if (!selectedCondominiumGroup) {
            return
        }

        this.setState({
            selectedCondominiumGroup: selectedCondominiumGroup,
            selectedLabel: selectedCondominiumGroup.label.trim(),
        })
        // 項目で表示しているエラーメッセージをクリア
        if (this.props.clearErrorMessage) {
            this.props.clearErrorMessage()
        }
        const selectedValue = selectedCondominiumGroup.value
        const selectedLabel = selectedCondominiumGroup.label
        this.props.onChangeSelectedCondominiumGroupId(selectedValue, selectedLabel)
    }

    render(): React.ReactElement {
        if (isMobile) {
            return <PPSelect
                eventEmitter={this.props.eventEmitter}
                eventKeys={this.props.eventKeys}
                data={this.state.condominiumGroupList
                    .map(option => ({label: option.label, value: `${option.value}`}))}
                onChange={this.onChangeCondominiumGroupIdM}
                value={`${this.state.selectedCondominiumGroup.value}`}
            />
        } else {
            return <LeftColumnFlexContainer style ={{fontSize:'0.875rem'}}>
                <Select
                    inputId={'selectCondominium'}
                    placeholder={SELECT_CONDOMINIUM_GROUP_PLACEHOLDER}
                    value={this.state.selectedCondominiumGroup}
                    options={this.state.condominiumGroupList}
                    onChange={this.onChangeCondominiumGroupId}
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({...base, zIndex: 9999}),
                        container: base => ({...base, width: '100%'}),
                        control: this.props.hasError
                            ? base => ({...base, borderColor: 'red', boxShadow: '0 0 0 1px red'})
                            : undefined,
                    }}
                    autoFocus={(this.props.autoFocus) ? true : false}
                />
                <FormErrorMessage
                    messages={
                        this.props.messages?.map((pair) => {
                            return {
                                message: pair.message,
                                params: [this.state.selectedLabel],
                            }
                        })
                    }
                />
            </LeftColumnFlexContainer>
        }
    }
}

export default withErrorSubscribe(NatCondominiumGroupSelectComponent)
